import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Loader } from '../'
import { actionFetchUsers } from '../../actions/users'
// import { actionFetchStores } from '../../actions/stores'
// import './selectorStates.css'
import { AppDispatch, RootState } from '../../reducers/store'
import { actionFetchAdmins } from '../../actions/admins'

const CountUsersSelector = () => {
    const dispatch                    = useDispatch<AppDispatch>();
    const { isLoading, totalNumber, currentPage }    = useSelector((state: RootState) => state.userList)
    useEffect(() => {
      dispatch(actionFetchUsers({currentPage})); // You can pass the page number as needed
    }, [dispatch, currentPage]);
  return (
    <>
      { isLoading ? <Loader /> : (
        <>{totalNumber}</>
      )}
    </>
  )
}

const CountAdminsSelector = () => {
    const dispatch                    = useDispatch<AppDispatch>();
    const { isLoading, totalNumber, currentPage }    = useSelector((state: RootState) => state.adminList)
    useEffect(() => {
      dispatch(actionFetchAdmins({currentPage})); // You can pass the page number as needed
    }, [dispatch, currentPage]);
  return (
    <>
      { isLoading ? <Loader /> : (
        <>{totalNumber}</>
      )}
    </>
  )
}


export  {
  CountUsersSelector,
  CountAdminsSelector,
}